import { Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import type { OrderValue as OrderValueType } from 'typings'
import { Tag } from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { messages } from './messages'

type OrderValueProps = {
  orderValue: OrderValueType | undefined
}

export function OrderValue(props: OrderValueProps) {
  const { formatMessage } = useIntl()
  const { formatCurrency } = useNumbers()
  const { orderValue } = props

  if (!orderValue) return null

  const { min, max } = orderValue

  if (min === undefined && max === undefined) return null

  const processTooltip = () => {
    if (min !== undefined && max === undefined) {
      return formatMessage(
        { ...messages.orderValue.min },
        {
          min: formatCurrency(min),
        }
      )
    }

    if (min === undefined && max !== undefined) {
      return formatMessage(
        { ...messages.orderValue.max },
        {
          max: formatCurrency(max),
        }
      )
    }

    if (min !== undefined && max !== undefined) {
      return formatMessage(
        { ...messages.orderValue.range },
        {
          max: formatCurrency(max),
          min: formatCurrency(min),
        }
      )
    }

    return ''
  }
  return (
    <Tooltip text={processTooltip()}>
      <Tag>
        <FormattedMessage {...messages.orderValue.title} />
      </Tag>
    </Tooltip>
  )
}
